import { AUTH_KEYS, getAuthToken } from '@/shared/utils/authStorage';

import { instance2 } from './base';

export const getServiceCases = (type = null, page = null, limit = null, search = null) =>
    instance2
        .get('/api/v1/customer-support/service-case', {
            params: {
                type: type,
                page: page,
                limit: limit,
                name: search,
                customer_id: getAuthToken(AUTH_KEYS.CUSTOMER_ID),
            },
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });

export const getServiceCaseDetails = (case_no) =>
    instance2
        .get(`/api/v1/customer-support/service-case/${case_no}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
